module.exports = __webpack_public_path__ + "static/media/combat(16).6c1ec150.PNG";